import script from "./DraggableNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./DraggableNotes.vue?vue&type=script&setup=true&lang=js"

import "./DraggableNotes.vue?vue&type=style&index=0&id=3642a56c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3642a56c"]])

export default __exports__